module.exports = __webpack_public_path__ + "static/media/librarian_framed2.5453f0c0.png";